import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import {
  createProfile,
  createUsera,
  loginUser,
  deleteUser,
  getAlluser,
  searchUser,
  sortUser,
  updateUser,
  getbyiduser,
  searchUserbyAge,
  RemoveImageintoGallery,
  uploadGalleryImage,
  changePasswordUser
} from "../Api/UserApi";

interface User {
  _id: string;
  name: string;
  password: string;
  email: string;
  DOB: string;
  phone_number: string;
  mode: string;
  iAm: "Male" | "Female";
  looking: "Male" | "Female";
  marial: "Single" | "Married";
  status: "active" | "inactive";
  city: string;
}

interface UserState {
  users: User[];
  user: any;
  page: any;
  loading: boolean;
  error: null | string;
  token: string | null;
  isAuthenticated: boolean;
}

const initialState: UserState = {
  users: [],
  user: [],
  page: 1,
  loading: false,
  error: null,
  token: null,
  isAuthenticated: false,

};

export const createUser = createAsyncThunk<User[], any>(
  'user/createUser',
  async (data: any) => {
    const { values, avatarFil } = data
    try {
      const response: AxiosResponse<any, any> | undefined = await createUsera(values);
      const id = response.data.data._id
      if (response.data.isSuccess) {
        uploadGalleryImage({ id, avatarFil })
      }
      return response.data as User[];
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  }
);

export const LoginUser = createAsyncThunk(
  "user/login",
  async (data: any, { rejectWithValue }) => {
    try {
      console.log(data);

      return await loginUser(data);
    } catch (err: any) {
      return rejectWithValue(err.message || "Login failed");
    }
  }
);

export const uploadGalleryImages = createAsyncThunk(
  'user/uploadGalleryImages',
  async (data: { id: string; avatarFil: File }, { rejectWithValue }) => {
    try {
      // If no file is provided, don't try to upload
      if (!data.avatarFil) {
        console.warn('No file provided for upload');
        return { success: false, message: 'No file provided' };
      }
      const response = await uploadGalleryImage(data);
      return response;
    } catch (error: any) {
      console.error('Upload error in thunk:', error);
      return rejectWithValue(error.message || 'Upload failed');
    }
  }
);

export const fetchUser = createAsyncThunk<User[], any>(
  'user/fetchUser',
  async (data: any) => {
    try {
      const response: AxiosResponse<any, any> | undefined = await getAlluser(data);
      return response.data as User[];
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  }
);

export const getbyidusers = createAsyncThunk<User[], any>(
  'user/getbyidusers',
  async (data: any) => {
    try {
      const response: AxiosResponse<any, any> | undefined = await getbyiduser(data);
      return response.data as User[];
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  }
);

export const fetchdeleteUser = createAsyncThunk<User[], any>(
  'user/fetchdeleteUser',
  async (id: any) => {
    try {
      const response: AxiosResponse<any, any> | undefined = await deleteUser(id);
      return response.data as User[];
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  }
);

export const fetchupdateUser = createAsyncThunk(
  'user/fetchupdateUser',
  async ({ editId, values }: { editId: any; values: any }, { rejectWithValue }) => {
    try {
      return await updateUser({ editId, values });
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const RemoveImageintoGallerys = createAsyncThunk<User[], any>(
  'user/RemoveImageintoGallerys',
  async (data: any) => {
    const { id, item } = data

    try {
      const response = await RemoveImageintoGallery(data);


      return response as any;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  }
);
// search 
export const fetchsearchUser = createAsyncThunk<User[], any>(
  'user/fetchsearchUser',
  async (data: any) => {
    try {
      const response: any = await searchUser(data);
      return response as User[];
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  }
);

export const searchUserbyAges = createAsyncThunk<User[], any>(
  'user/searchUserbyAges',
  async (data: { mode: string; gender: string; minAge: number; maxAge: number }) => {
    try {
      const response = await searchUserbyAge({
        mode: data.mode,
        gender: data.gender,
        minAge: data.minAge,
        maxAge: data.maxAge
      });
      console.log("responseeeeee:", response)
      return response as User[];
    } catch (error) {
      console.error("Error searching users by age:", error);
      throw error;
    }
  }
);
// sortUser
export const fetchsortUser = createAsyncThunk<User[], any>(
  'user/fetchsortUser',
  async (sort: any) => {
    try {
      const response: any = await sortUser(sort);
      return response as User[];
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  }
);
//changePassword
export const changePassword = createAsyncThunk<any, any>(
  'user/changePasswordUser',
  async (data, { rejectWithValue }) => {
    try {
      const result = await changePasswordUser(data); // Already parsed JSON
      return result; // { isSuccess, message }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


const userSlice: any = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {

    setPage: (state, action) => {
      state.page = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUser.fulfilled, (state, action: any) => {
        // state.users = action.payload;

        state.loading = false;
      })
      .addCase(createUser.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.loading = false;
        state.error = "error";
      })
      /* LOGIN */
      .addCase(LoginUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(LoginUser.fulfilled, (state, action: any) => {

        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        localStorage.setItem("token", action.payload.token);
      })
      .addCase(LoginUser.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchUser.fulfilled, (state, action) => {
        state.users = action.payload;
        state.loading = false;
      })
      .addCase(getbyidusers.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
      })
      //   delete
      .addCase(fetchdeleteUser.fulfilled, (state, action) => {
        // const alldata= state.users.filter((items:any)=>items._id!==action.payload._id)
        // state.users.push(...action.payload);
        state.loading = false;
      })
      // search
      .addCase(fetchsearchUser.fulfilled, (state, action) => {
        state.users = action.payload;
        state.loading = false;
      })
      // Filter by age
      .addCase(searchUserbyAges.fulfilled, (state, action) => {
        state.users = action.payload;
        state.loading = false;
      })
      // fetchsortUser
      .addCase(fetchsortUser.fulfilled, (state, action) => {
        state.users = action.payload;
        state.loading = false;
      })
      .addCase(RemoveImageintoGallerys.fulfilled, (state, action) => {

        state.loading = false;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
      })
  },
});
export const { setPage } = userSlice.actions

export default userSlice.reducer;
